//Countries
export var country_list = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

//Part Types
export var partUnits = [
  "KGS",
  "BCH",
  "PCS",
  "PKT",
  "LTR",
  "CUP",
  "TIN",
  "C/T",
  "BTL",
  "SET",
  "PRS",
  "DOZ",
  "TUB",
  "SHT",
  "C/L",
  "MTR",
  "RLS",
  "C/S",
  "CTN",
  "BDL",
  "BOX",
  "LGH",
  "HNK",
  "BAL",
  "GRS",
  "BAG",
  "DRM",
  "CAN",
  "TON",
  "KIT",
  "TAB",
  "VOL",
  "TIM",
  "PAD",
  "JAR",
  "PKG",
  "KEG",
  "BKT",
  "SPL",
  "PAK",
  "M3",
  "CYL",
];
//["Bag","Box","Btl","Can","Ctn","Cbm","Drm","Doz","Kgs","Mtr","Pac","Pcs","Prs","Rol","Set","Tbl","Tub","Unt"]

//Catalogues
export var catalogues = ["IMPA", "RS", "SSI"];

//Account categories
export var accountsCategoryList = [
  "Crew Earnings and Expenses",
  "Provisions",
  "Insurance",
  "Lubricants",
  "Repairs/Maintenance/Spares",
  "Stores",
  "Transport",
  "Classification Costs",
  "ISM/ISPS/MLC and Other Vettings",
  "Other Costs",
  "Management Expenses",
  "Bond Stores",
  "Costs Outside Budget",
];

// Purchase order lists:
export var departments = ["Engine", "Deck"];

export var requisition_types = ["Spares", "Service", "Stores"];

export var priorities = [
  "Safety",
  "Next Convenient Port",
  "Quarterly Supply",
  "Urgent",
];

//Status types
export var status_types = [
  "draft",
  "approved by crew",
  "approved by office",
  "not approved by office",
  "rejected",
  "inquired",
  "vendor approved",
  "PO placed",
  "items in transit",
  "items received",
  "invoice received",
  "canceled",
  "archived",
  "dry dock",
];

export const optionsForLocationBlock = ["New location"];

export const certificateCategories = ["Mandatory", "Optional"];

export const endorsementPeriod = ["6 months", "1 year", "2 years", "5 years"];
export const endorsementAllowance = ["±3 Months", "±6 Months"];
export const certificateTypes = [
  "Class Certificates",
  "Flag Certificates",
  "Insurance Certificates",
  "Miscellaneous Certificates",
];
//Invoice Verification Complete
export const invoiceStatus = [
  { label: "New", value: "New" },
  { label: "Approved", value: "Approved" },
  { label: "For payment", value: "For payment" },
  { label: "Paid", value: "Paid" },
  { label: "Canceled", value: "Canceled" },
  { label: "Rejected", value: "Rejected" },
  { label: "Duplicate", value: "Duplicate" },
  { label: "OCR", value: "OCR" },
];

export const invoiceDepartments = [
  { label: "Technical", value: "Technical" },
  { label: "Crewing", value: "Crewing" },
  { label: "Operations", value: "Operations" },
  { label: "Accounting", value: "Accounting" },
  { label: "Unassigned", value: "" },
];

export const invoiceTypeOptions = [
  { label: "Service", value: "Service" },
  { label: "Stores", value: "Stores" },
  { label: "Spares", value: "Spares" },
  { label: "Repairs", value: "Repairs" },
  { label: "Operational", value: "Operational" },
  { label: "Classification", value: "Classification" },
  { label: "Provision", value: "Provision" },
  { label: "Lubricants", value: "Lubricants" },
  { label: "Bond stores", value: "Bond stores" },
  { label: "Outside the budget", value: "Outside the budget" },
];

export const invoiceBankNamesOptions = [
  { label: "Hellenic", value: "Hellenic" },
  { label: "Citibank", value: "Citibank" },
  { label: "Emirates NBD", value: "Emirates NBD" },
];

export const selectAllOptions = [
  { label: "Draft", value: "draft" },
  { label: "Approved by crew", value: "approved by crew" },
  { label: "Approved by office", value: "approved by office" },
  { label: "Not approved by office", value: "not approved by office" },
  { label: "Rejected", value: "rejected" },
  { label: "Inquired", value: "inquired" },
  { label: "Vendor approved", value: "vendor approved" },
  { label: "PO placed", value: "po placed" },
  { label: "Items in transit", value: "items in transit" },
  { label: "Items received", value: "items received" },
  { label: "Invoice received", value: "invoice received" },
  { label: "Canceled", value: "canceled" },
];

export const currencyOptions = [
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" },
  { label: "GBP", value: "GBP" },
  { label: "AED", value: "AED" },
  { label: "DKK", value: "DKK" },
  { label: "CNY", value: "CNY" },
  { label: "JPY", value: "JPY" },
  { label: "SGD", value: "SGD" },
  { label: "TRY", value: "TRY" },
  { label: "AUD", value: "AUD" },
  { label: "CAD", value: "CAD" },
  { label: "CHF", value: "CHF" },
  { label: "INR", value: "INR" },
  { label: "RUB", value: "RUB" },
];

export const invoiceVesselsOptions = [
  { label: "Autan", value: "Autan" },
  { label: "Cers", value: "Cers" },
  { label: "Gas Spanakopita", value: "Gas Spanakopita" },
  { label: "Grace Ferrum", value: "Grace Ferrum" },
  { label: "Grace Leo", value: "Grace Leo" },
  { label: "Grace Romavictor", value: "Grace Romavictor" },
  { label: "Gregal", value: "Gregal" },
  { label: "Llevant", value: "Llevant" },
  { label: "Mestral", value: "Mestral" },
  { label: "Migjorn", value: "Migjorn" },
  { label: "Vendavel", value: "Vendavel" },
  { label: "Arendal Spirit", value: "Arendal Spirit" },
  { label: "BELAIT CSS 1", value: "BELAIT CSS 1" },
  { label: "Nor Spirit", value: "Nor Spirit" },
  { label: "Nor Naomi", value: "Nor Naomi" },
  { label: "Temis", value: "Temis" },
];

export const documentTypeOptions = [
  { label: "Invoice", value: "Invoice" },
  { label: "Credit Note", value: "Credit Note" },
  { label: "Debit Note", value: "Debit Note" },
  { label: "Proforma Invoice", value: "Proforma Invoice" },
  { label: "Other", value: "Other" },
];
